export default __webpack_public_path__ + "static/media/files.05f97dea.svg";